'use client'
import React from 'react'
import {
  Box,
  Button,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useBreakpointValue,
} from '@chakra-ui/react'

import { ChevronDownIcon } from 'lucide-react'
import { usePathname } from 'next/navigation'

type FilterType = {
  earnings: boolean
  watchtime: boolean
  views: boolean
  subscriber: boolean
}

type CreatorEarningFilterProps = {
  filterType: FilterType
  setFilterType: React.Dispatch<React.SetStateAction<FilterType>>
  handleCreatorEarningsChange: (value: FilterType) => void
}

const WatchtimeDropdown: React.FC<CreatorEarningFilterProps> = ({
  filterType,
  setFilterType,
}) => {
  const iconSize = useBreakpointValue({ base: 2, sm: 5 })
  const pathname = usePathname()
  const isAllVideo = pathname === '/creator-analytics/all-videos' ? true : false
  // const handleCreatorEarningsChange = (value: keyof FilterType) => {
  //   setFilterType((prevState) => {
  //     const newState = {
  //       ...prevState,
  //       [value]: !prevState[value],
  //     }

  //     const allChecked = Object.keys(newState)
  //       .filter((key) => key !== 'earnings')
  //       .every((key) => newState[key as keyof FilterType])

  //     return {
  //       ...newState,
  //       earnings: allChecked,
  //     }
  //   })
  // }

  const handleCreatorEarningsChange = (value: keyof FilterType) => {
    const drop: FilterType = {
      earnings: false,
      views: false,
      watchtime: false,
      subscriber: false,
    }
    setFilterType({
      ...drop,
      [value]: true,
    })
  }

  const selectedFilter = (
    Object.keys(filterType) as (keyof FilterType)[]
  ).find((key) => filterType[key])

  const filterLabels: Record<keyof FilterType, string> = {
    earnings: 'Watch Time Earnings (in LYK Coins)',
    watchtime: 'Watchtime',
    views: 'Views',
    subscriber: 'Subscribers',
  }

  const menuButtonLabel = selectedFilter
    ? filterLabels[selectedFilter]
    : 'Select Filter'

  return (
    <Box>
      <Menu closeOnSelect={true} placement="bottom-start">
        <MenuButton
          as={Button}
          opacity={0.9}
          className="no-underline"
          bg={'white'}
          minW={'auto'}
          rightIcon={
            <Icon
              as={ChevronDownIcon}
              height={iconSize}
              width={iconSize}
              color={'#656565'}
            />
          }
          border={'2px !important'}
          pl={{ base: '5px !important', sm: '10px !important' }}
          pr={{ base: '1px !important', sm: '8px !important' }}
          borderColor={'#D3D3D3 !important'}
          color={'#656565'}
          _hover={{ bg: 'white' }}
          _active={{ bg: 'white' }}
          fontWeight="600"
          size={{ base: 'xs', sm: 'md' }}
        >
          {menuButtonLabel}
        </MenuButton>
        <MenuList zIndex="popover" className="p-2 text-black" boxShadow="lg">
          <MenuItem
            className="mt-1 rounded-md"
            bg={'transparent'}
            color={filterType.earnings ? '#656565' : '#9F9F9F'}
            onClick={() => handleCreatorEarningsChange('earnings')}
          >
            {/* Earnings */}
            Watch Time Earnings (in LYK Coins)
          </MenuItem>
          {/* <MenuItem
            className="mt-1 rounded-md"
            bg={'transparent'}
            color={filterType.watchtime ? '#656565' : '#9F9F9F'}
            onClick={() => handleCreatorEarningsChange('watchtime')}
          >
            Watchtime
          </MenuItem>{' '} */}
          <MenuItem
            className="mt-1 rounded-md"
            bg={'transparent'}
            color={filterType.views ? '#656565' : '#9F9F9F'}
            onClick={() => handleCreatorEarningsChange('views')}
          >
            Views
          </MenuItem>{' '}
          {isAllVideo && (
            <MenuItem
              className="mt-1 rounded-md"
              bg={'transparent'}
              color={filterType.subscriber ? '#656565' : '#9F9F9F'}
              onClick={() => handleCreatorEarningsChange('subscriber')}
            >
              Subscribers
            </MenuItem>
          )}
        </MenuList>
      </Menu>
    </Box>
  )
}

export default WatchtimeDropdown
